var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"policy-content",domProps:{"innerHTML":_vm._s(_vm.htmlContent)}})
}
var staticRenderFns = []

export { render, staticRenderFns }